import React from 'react';
import { Icons } from './Icons';

interface HeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAddPatient: () => void;
  onBookAppointment: () => void;
  showAddPatient?: boolean;
  onToggleMenu?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  searchQuery,
  onSearchChange,
  onAddPatient,
  onBookAppointment,
  showAddPatient = true,
  onToggleMenu,
}) => {
  return (
    <header className="bg-white border-b border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-3 px-4 sm:px-6 py-4">
      <div className="flex items-center gap-3 w-full md:w-auto">
        {onToggleMenu && (
          <button
            type="button"
            onClick={onToggleMenu}
            className="lg:hidden p-3 rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50"
            aria-label="Toggle menu"
          >
            <Icons.Menu />
          </button>
        )}
        <div className="relative flex-1 md:w-96">
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
            <Icons.Search className="w-5 h-5" />
          </div>
          <input
            type="text"
            placeholder="Search patients..."
            className="w-full pl-12 pr-4 py-3 bg-white border-2 border-slate-200 rounded-2xl text-sm font-medium focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all placeholder:text-slate-400"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>
      <div className="flex flex-wrap gap-2 md:justify-end">
        {showAddPatient && (
          <button
            onClick={onAddPatient}
            className="px-5 py-2.5 bg-white border border-slate-200 text-slate-600 font-bold text-sm rounded-xl hover:bg-slate-50"
          >
            + Add Patient
          </button>
        )}
        <button
          onClick={onBookAppointment}
          className="px-5 py-2.5 bg-blue-600 text-white font-bold text-sm rounded-xl shadow-lg hover:bg-blue-700"
        >
          + Book Appointment
        </button>
        {/* <button
          type="button"
          onClick={onLogout}
          className="px-3 py-2 rounded-xl border text-xs font-bold hover:bg-slate-50"
        >
          Logout
        </button> */}
      </div>
    </header>
  );
};
